import styled from 'styled-components';

export const NavBarContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
`;

export const BackButton = styled.button`
  height: 28px;
  border: 0;
  border-radius: 4px;
  padding: 4px 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background: transparent;
  cursor: pointer;
`;

export const BackLabel = styled.span`
  color: ${(props) => props.theme.colors.darkGray};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: normal;
  text-decoration: underline;
  text-decoration-skip-ink: none;
  white-space: nowrap;
`;

export const BreadcrumbText = styled.p`
  flex: 1;
  margin: 0;
  color: ${(props) => props.theme.colors.davysGrey};
  font-family: ${(props) => props.theme.fonts.family.inter};
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  text-align: right;
`;
